import checkout from "./form";

const {
  formField: {
    fullName,
    signer,
    certificate,
    timeSign,

    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,

    taxpayerName,
    taxpayerId,

    capitalTransfereeName,
    capitalTransfereeTp,
    capitalTransfereeDistrict,
    capitalTransfereeTaxId,
    capitalTransfereeWards,
    capitalTransfereeAddress,

    realEstateTp,
    realEstateDistrict,
    realEstateWards,
    realEstateAddress,

    taxAgentName,
    taxAgentId,

    contractNumber,
    contractDay,
    confirmContractDay,
  },
} = checkout;

const initialValues = {
  [fullName.name]: "",
  [signer.name]: "",
  [certificate.name]: "",
  [timeSign.name]: "",

  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [taxCalculationPeriod.name]: "",

  [taxpayerName.name]: "",
  [taxpayerId.name]: "",

  [capitalTransfereeName.name]: "",
  [capitalTransfereeTp.name]: "",
  [capitalTransfereeDistrict.name]: "",
  [capitalTransfereeTaxId.name]: "",
  [capitalTransfereeWards.name]: "",
  [capitalTransfereeAddress.name]: "",

  [realEstateTp.name]: "",
  [realEstateDistrict.name]: "",
  [realEstateWards.name]: "",
  [realEstateAddress.name]: "",

  [taxAgentName.name]: "",
  [taxAgentId.name]: "",

  [contractNumber.name]: "",
  [contractDay.name]: "",
  [confirmContractDay.name]: "",
};

export default initialValues;
